export enum Role {
  ADMIN = 'ADMIN',
  SELLER = 'SELLER',
  SPY = 'SPY',
  SHOP_MANAGER = 'SHOP_MANAGER',
}
